
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Button extends Vue {
  @Prop() readonly primary!: boolean | string;

  @Prop() readonly icon!: boolean | string;

  blockName = 'button';

  get getTheme() {
    return {
      [`${this.blockName}--primary`]: this.primary === '',
      [`${this.blockName}--icon`]: this.icon === '',
    };
  }
}
